export enum AuthActionType {
  APP_LOGOUT = 'auth/APP_LOGOUT',
  SESSION_DESTROY_REQUEST = 'auth/SESSION_DESTROY_REQUEST',
  SESSION_DESTROY_SUCCESS = 'auth/SESSION_DESTROY_SUCCESS',
  SESSION_DESTROY_FAILURE = 'auth/SESSION_DESTROY_FAILURE',
  CHECK_AUTH_SUCCESS = 'auth/CHECK_AUTH_SUCCESS',
  CHECK_AUTH_FAILURE = 'auth/CHECK_AUTH_FAILURE',
}
